/* product-addons.js — "Add Offer" cross-sell on the PDP. Each add-on adds itself
   to the cart via /cart/add.js (independent of the main product form), updates
   Dawn's cart count bubble, and shows brief button feedback. Dependency-free.

   NAME-TO-BE-PRINTED VALIDATION (TC-233 → TC-293)
   -------------------------------------------------------------------------
   The "Add" / "Get Bundle" button used to be DISABLED (dimmed + pointer-events
   + aria-disabled) while a required King ("ymq") "Name to be printed" field was
   empty. TC-293 removes that: no CTA is greyed out for the empty-name case
   anymore. The button now renders fully enabled and is validated AT CLICK TIME,
   exactly like Add to Cart / Buy Now.

   assets/pdp-personalisation.js is the SINGLE OWNER of that click-time gate: it
   has a capture-phase click/pointerdown listener over ATC + the express-checkout
   buttons + .paddon__add that, when a required name is empty, calls
   preventDefault + stopImmediatePropagation (so this file's own add-to-cart
   click handler below never runs), shows the centered Zippy mascot and focuses
   the name field. So this file MUST NOT add a competing gate — two gates on one
   element corrupt each other. It no longer dims/disables .paddon__add and no
   longer blocks the offer-add itself; when the name IS filled the click reaches
   the handler below and the offer is added normally. */
(function () {
  // ---- de-dup the universal fallback --------------------------------------
  // buy-buttons.liquid renders a shop-wide "Add Offer" fallback (tagged
  // data-paddons-fallback) on every offer-capable template, because it cannot see
  // section.blocks to know whether the template already has its own merchant-placed
  // Add-ons block. When both exist, keep the merchant-placed one and drop the
  // fallback so the offer never shows twice.
  function dedupeFallback() {
    var all = document.querySelectorAll('.paddons');
    var hasReal = false;
    Array.prototype.slice.call(all).forEach(function (el) {
      if (!el.hasAttribute('data-paddons-fallback')) hasReal = true;
    });
    if (!hasReal) return;
    Array.prototype.slice.call(document.querySelectorAll('.paddons[data-paddons-fallback]')).forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  var dedupeTimer = null;
  function scheduleDedupe() {
    if (dedupeTimer) return;
    dedupeTimer = setTimeout(function () { dedupeTimer = null; dedupeFallback(); }, 120);
  }

  // King renders / re-renders its options asynchronously (and on variant change),
  // which can re-inject a duplicate fallback block. Keep de-duping on mutations.
  function watchKing() {
    dedupeFallback();
    try {
      new MutationObserver(scheduleDedupe)
        .observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) { /* dedupe still ran once above */ }
  }
  if (document.readyState !== 'loading') watchKing();
  else document.addEventListener('DOMContentLoaded', watchKing);

  // ---- add-on add-to-cart --------------------------------------------------
  function updateBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var host = document.getElementById('cart-icon-bubble');
    if (!host) return;
    try {
      var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      // The returned section HTML wraps the bubble content; take the inner of the
      // .shopify-section wrapper (or #cart-icon-bubble / body as fallbacks).
      var wrap = doc.querySelector('.shopify-section') || doc.getElementById('cart-icon-bubble') || doc.body;
      if (wrap) host.innerHTML = wrap.innerHTML;
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-addon-add]');
    if (!btn || btn.disabled) return;
    // No name-gate here anymore: pdp-personalisation.js's capture-phase listener
    // blocks the click (preventDefault + stopImmediatePropagation) and shows the
    // mascot BEFORE this bubble-phase handler ever runs when a required name is
    // empty. If we get here, the name is filled (or the product isn't
    // personalised) — add the offer normally.
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (data) {
        updateBubble(data.sections);
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        // Let Dawn refresh any cart drawer/notification listeners if present.
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-addons' }); } catch (e) {}
        }
        setTimeout(function () { btn.textContent = original; btn.disabled = false; btn.classList.remove('is-added'); }, 1800);
      })
      .catch(function () { btn.textContent = original; btn.disabled = false; });
  });
})();
